import { buildRequest } from './request'

const request = buildRequest('/api/front/v1')

export type AgentInfo = {
  title: string
  logoUrl: string
  tagName: string
  email: string
  address: string
  website: string
  contactInfo: string
  telephone: string
}

export type AgentList = {
  agentFirstRegion: Array<{
    title: string
    category: Array<{
      title: string
      agentItems: AgentInfo[]
    }>
  }>
}

// 代理商列表
export async function getAgentList(): Promise<AgentList> {
  const res = await request('/agent/list')
  return res
}

getAgentList.swrkey = (locale: string) => `/${locale}/api/front/v1/agent/list`

// 用户订阅
export async function subscribe(email: string) {
  const res = await request('/subscribe', { email })
  return res
}
